import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export type UpdateCompanyParityPayload = {
  uuid: string;
  name?: string;
  parity: number;
};

export const useUpdateCompanyParity = (
  options?: UseMutationOptions<any, Error, UpdateCompanyParityPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateCompanyParity"],
    mutationFn: async ({ uuid, name, parity }) => {
      return axiosInstance
        .put(`/companies/${uuid}/parity`, { name, parity })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa zmiana rodzaju spółki...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "update-company-parity",
      });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: async (data, variables, context) => {
      Toast({
        message: "Rodzaj spółki został zmieniony",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "update-company-parity",
      });
      await queryClient.invalidateQueries({
        queryKey: ["companies"],
        refetchType: "all",
      });
      await queryClient.invalidateQueries({
        queryKey: ["companies/my"],
        refetchType: "all",
      });
      await queryClient.invalidateQueries({
        queryKey: ["shares/company"],
        refetchType: "all",
      });
      if (options && options.onSuccess) {
        await options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Wystąpił problem ze zmianą rodzaju spółki",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-company-parity",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateCompanyParity;
